import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { MdClose } from 'react-icons/md';
import './Drawer.css';

const Drawer = ({ isOpen, onClose, title, children }) => {
    // Prevent scrolling when drawer is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <div className="drawer-overlay" onClick={onClose}>
            <div 
                className={`drawer-content ${isOpen ? 'open' : ''}`} 
                onClick={(e) => e.stopPropagation()}
            >
                <div className="drawer-header">
                    <h3>{title}</h3>
                    <button className="drawer-close-btn" onClick={onClose}>
                        <MdClose />
                    </button>
                </div>
                <div className="drawer-body">
                    {children}
                </div>
            </div>
        </div>,
        document.body
    );
};

export default Drawer;
